import Text from 'common-components/Text'
import styled from 'styled-components'

interface ICharacterCountIndicatorWrapperProps {
  $isDisabled: boolean
}

export const CharacterCountIndicatorWrapper = styled(
  Text
)<ICharacterCountIndicatorWrapperProps>`
  margin-top: 8px;
  width: 100%;
  max-width: 250px;
  display: flex;
  gap: 5px;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
`

export const CountLimit = styled.span`
  width: 28px;
  min-width: fit-content;
  text-align: end;
`

export const TextCountLimit = styled.span`
  width: 100%;
`
